import { Upload, type LucideIcon } from "lucide-react";

/**
 * Full-window overlay shown while files are dragged over a view that accepts
 * them (see usePageFileDrop). `label` names the action ("Drop to upload logo");
 * `hint` names what's accepted. It never takes pointer events, so the drop
 * lands on the page underneath.
 */
export function FileDropOverlay({
  show,
  label,
  hint,
  icon: Icon = Upload,
}: {
  show: boolean;
  label: string;
  hint?: string;
  icon?: LucideIcon;
}) {
  if (!show) return null;
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-50 flex bg-background/75 p-4 backdrop-blur-[2px] animate-in fade-in-0 duration-150 motion-reduce:animate-none"
    >
      <div className="flex flex-1 flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-primary/60 bg-primary/5">
        <div className="flex size-14 items-center justify-center rounded-full bg-primary/10 text-primary animate-in zoom-in-90 duration-200 motion-reduce:animate-none">
          <Icon className="size-6" />
        </div>
        <p className="text-lg font-semibold">{label}</p>
        {hint && <p className="text-sm text-muted-foreground">{hint}</p>}
      </div>
    </div>
  );
}
